import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { parseQueryParams } from '../helpers';

export const useParsedQueryParams = <T extends Record<string, string>>() => {
  const location = useLocation();
  return useMemo(() => parseQueryParams(location.search) as T, [location.search]);
};
